export default __webpack_public_path__ + "static/media/Sulla_spiaggia_d_inverno_Guiliano_Censini_50x50.8ba24962.jpg";